module.exports = __webpack_public_path__ + "img/yishi20.940c8f34.jpg";